/** Faits reçus seulement. Rien d'inventé (heure exacte du départ, propriétaires véhicules, allergies). */

export const SEPAQ_CHALET_URL =
  "https://www.sepaq.com/fr/reservation/chalet/reserve-faunique-de-portneuf/desrochers/desrochers";

export const AVENZA_OFFICIAL_URL =
  "https://store.avenza.com/products/lac-desrochers-portneuf-sepaq-map";

export const EXPEDITION = {
  id: "trip_terrain_3j",
  title: "EXPÉDITION PORTNEUF 2026",
  subtitle: "Chalet Desrochers — Secteur 4",
  departBadge: "28–30 août 2026",
  reserveBadge: "Réserve faunique de Portneuf",
  sectorBadge: "Secteur de chasse no 4",
  reconBadge: "54,55 km²",
  memberBadge: "6 membres",
  countdown: "Départ tôt le matin — heure exacte à confirmer",
  arrive: "Arrivée officielle chalet à partir de 17 h",
  lodgingName: "Chalet Desrochers",
  sectorName: "Secteur de chasse no 4",
  compactLine: "Secteur 4 → Chalet Desrochers → Retour dimanche 13 h 30",
  mapCenter: { lat: 47.241881, lng: -72.484323, zoom: 12 },
  mapNote: "Limite officielle secteur 4 — 54,55 km². Carte terrain : NordQuest.",
  avenzaMap: "Lac Desrochers (Portneuf) — Sépaq / Avenza Maps",
  timeline: [
    { id: "prep", label: "Préparation", status: "planned" },
    { id: "friday", label: "Vendredi", status: "confirmed" },
    { id: "saturday", label: "Samedi", status: "planned" },
    { id: "sunday", label: "Dimanche", status: "confirmed" },
  ],
};

export const LODGING = {
  name: "Chalet Desrochers",
  sector: "Desrochers",
  reserve: "Réserve faunique de Portneuf",
  sourceUrl: SEPAQ_CHALET_URL,
  sourceName: "Sépaq",
  consulted: "2026-08-26",
  holder: "Luc Young",
  reservation: "39632719",
  checkIn: "Vendredi 28 août 2026 à 17 h 00",
  checkOut: "Dimanche 30 août 2026 à 13 h 30",
  amount: "568,59 $",
  water: "Eau non potable — apporter de l’eau embouteillée",
  groupBedTip: "Recommandation du groupe : sac de couchage individuel",
};

export const PUBLIC_SERVICES = {
  reception: {
    title: "Accueil Sépaq — Rivière-à-Pierre",
    titleEn: "Sépaq registration — Rivière-à-Pierre",
    address: "229, rue du Lac Vert, Rivière-à-Pierre, Québec G0A 3A0",
    phone: "418 323-2021",
    nearby: "Rivière-à-Pierre, à environ 2 km de l'accueil : épicerie, essence, resto-bar, casse-croûte.",
    nearbyEn: "Rivière-à-Pierre, about 2 km from registration: grocery, fuel, resto-bar, snack.",
    services: "Information, enregistrement, location, eau, glace, permis, bois, appâts.",
    servicesEn: "Information, check-in, rental, water, ice, permits, wood, bait.",
    source: "Sépaq",
    url: "https://www.sepaq.com/rf/por/information.dot",
    consulted: "2026-08-26",
  },
  motorized: {
    title: "Déplacements motorisés",
    titleEn: "Motor travel",
    rule: "Utilisation des VTT / côte-à-côte autorisée seulement selon les sentiers et règles applicables. Circulation sur les routes interdite selon le document.",
    ruleEn: "ATV / side-by-side use is allowed only on applicable trails and rules. Road travel is forbidden according to the document.",
    verify: "Toujours vérifier la réglementation applicable au moment du séjour.",
    verifyEn: "Always check the rules that apply at the time of the trip.",
    source: "Confirmation Sépaq",
    url: "/docs/Confirmation-39632719-111037.pdf",
    consulted: "2026-08-26",
  },
  sectors: ["Bellevue", "Desrochers", "Lac-de-Travers", "Lapeyrère", "Rivière-à-Pierre", "Talbot"],
};

export const PUBLIC_RESOURCES = [
  {
    id: "chalet",
    icon: "⛺",
    title: "Chalet Desrochers",
    url: SEPAQ_CHALET_URL,
    source: "Sépaq",
    consulted: "2026-08-26",
    kind: "hebergement",
    note: "Page officielle d'hébergement. Photos Sépaq : voir sur le site, pas réutilisées ici.",
    noteEn: "Official lodging page. Sépaq photos stay on their site.",
  },
  {
    id: "reserve",
    icon: "🌲",
    title: "Réserve faunique de Portneuf",
    url: "https://www.sepaq.com/rf/por/",
    source: "Sépaq",
    consulted: "2026-08-26",
    kind: "territoire",
    note: "Information générale. 6 secteurs dont Desrochers.",
    noteEn: "General information. 6 sectors including Desrochers.",
  },
  {
    id: "accueil",
    icon: "ℹ",
    title: "Information / accueil",
    url: "https://www.sepaq.com/rf/por/information.dot",
    source: "Sépaq",
    consulted: "2026-08-26",
    kind: "accueil",
    note: "Accueil, services, règlements saisonniers.",
    noteEn: "Registration, services, seasonal rules.",
  },
  {
    id: "cartes",
    icon: "🗺",
    title: "Cartothèque / cartes",
    url: "https://www.sepaq.com/rf/por/information.dot",
    source: "Sépaq",
    consulted: "2026-08-26",
    kind: "carte",
    note: "Documentation, fichiers GPS et cartes officielles de la réserve.",
    noteEn: "Official documentation, GPS files and maps for the reserve.",
  },
  {
    id: "reglements",
    icon: "📜",
    title: "Règlements",
    url: "https://www.sepaq.com/rf/por/",
    source: "Sépaq",
    consulted: "2026-08-26",
    kind: "reglement",
    note: "Règlements de chasse et modalités saisonnières. Toujours vérifier avant le séjour.",
    noteEn: "Hunting rules and seasonal terms. Always check before the trip.",
  },
  {
    id: "avenza",
    icon: "⌖",
    title: "Avenza — Lac Desrochers",
    url: AVENZA_OFFICIAL_URL,
    source: "Avenza Map Store",
    consulted: "2026-08-28",
    kind: "carte",
    note: "Carte officielle du lac. Pas le chalet, pas le secteur 4.",
    noteEn: "Official lake map. Not the cabin, not sector 4.",
  },
];

export const STAY_RESOURCE_IDS = ["chalet", "reserve", "cartes", "accueil"];

export const AVENZA_NOTE =
  "Ancien outil utilisé pendant la prospection : Avenza. La carte terrain du groupe se prépare dans NordQuest. Formats de référence : GPX, KML/KMZ, CSV.";

export const KNOW_BEFORE = [
  { id: "water", fr: "Eau non potable — apporter de l’eau embouteillée.", en: "Water is not potable — bring bottled water.", level: "critical" },
  { id: "bedding", fr: "Literie à apporter : draps, couvertures ou sac de couchage, couvre-oreiller, couvre-matelas, serviettes, débarbouillettes. Oreillers, tapis de bain et linge à vaisselle fournis.", en: "Bring sheets, blankets or a sleeping bag, pillow cover, mattress cover, towels and washcloths. Pillows, bath mats and dish towels are provided." },
  { id: "sopfeu", fr: "Vérifier l’indice de danger d’incendie le jour du départ.", en: "Check the fire danger index on departure day." },
  { id: "vtt", fr: "VTT / côte-à-côte : sentiers et règles applicables seulement. Circulation sur les routes interdite selon la confirmation Sépaq.", en: "ATV / side-by-side: applicable trails and rules only. Road travel is forbidden per the Sépaq confirmation." },
  { id: "drone", fr: "Pas de drone récréatif.", en: "No recreational drone." },
  { id: "clean", fr: "Logement à laisser propre.", en: "Leave the cabin clean." },
  { id: "defect", fr: "Équipement défectueux à signaler.", en: "Report defective equipment." },
];
